import * as React from "react";
import { Form } from "react-bootstrap";
import { config } from '_config';

export default function ComprehensiveSearchStep1({state, onChange, validated}) {

  const handleChange = (e) => {
      onChange(e)
  };

  return (
            <Form id="TrademarkForm" noValidate validated={validated}>
              <div className="question">
                {config.skin === 'v2-basic' && <h2>Trademark Name</h2>}
                <div className="polaroid">
                  <p className="primary-label">Select what you are trying to protect</p>

                  <div key={`inline-radio`} className="mb-3">
                    <Form.Check
                      inline
                      label="Name"
                      name="trademarkType"
                      type="radio"
                      id="type1"
                      value={"NAME"}
                      checked={state.trademarkType === "NAME"}
                      onChange={handleChange}
                    />
                    <Form.Check
                      inline
                      label="Slogan"
                      name="trademarkType"
                      id="type2"
                      type="radio"
                      value={"SLOGAN"}
                      checked={state.trademarkType === "SLOGAN"}
                      onChange={handleChange}
                    />
                    <Form.Check
                      inline
                      label="Logo"
                      name="trademarkType"
                      id="type3"
                      type="radio"
                      value={"LOGO"}
                      checked={state.trademarkType === "LOGO"}
                      onChange={handleChange}
                    />
                  </div>
                  {state.trademarkType === "NAME" ? (
                    <>
                      <Form.Group className="mb-3" controlId="markDesc">
                        <Form.Label required>the name you wish to protect</Form.Label>
                        <Form.Control
                          type="text"
                          required
                          placeholder="Enter the name you wish to protect"
                          onChange={handleChange}
                          data-hj-allow
                          value={state.markDesc ? state.markDesc : ""}
                        />
                        <Form.Control.Feedback type="invalid">Please provide a valid name</Form.Control.Feedback>
                      </Form.Group>{" "}
                    </>
                  ) : null}
                  {state.trademarkType === "SLOGAN" ? (
                    <>
                      <Form.Group className="mb-3" controlId="markDesc">
                        <Form.Label required>Enter the slogan you wish to protect</Form.Label>
                        <Form.Control
                          type="text"
                          required
                          placeholder="Enter the slogan you wish to protect"
                          onChange={handleChange}
                          data-hj-allow
                          value={state.markDesc ? state.markDesc : ""}
                        />
                        <Form.Control.Feedback type="invalid">Please provide a valid slogan</Form.Control.Feedback>
                      </Form.Group>
                    </>
                  ) : null}
                  {state.trademarkType === "LOGO" ? (
                    <>
                      <Form.Group className="mb-3" controlId="literalElements">
                        <Form.Label required>
                          Please provide a complete and accurate description of your logo, including any words that may
                          appear in the logo. An example of a description is: ‘a red cat wrapped around a blue outline of a
                          globe’. Leave out the colors if you want to protect your logo in all colors
                        </Form.Label>
                        <Form.Control
                          type="text"
                          required
                          placeholder=""
                          onChange={handleChange}
                          data-hj-allow
                          value={state.literalElements ? state.literalElements : ""}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please provide a complete and accurate description of your logo
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group className="mb-3" controlId="markDesc">
                        <Form.Label required>Enter any word(s), letter(s), and/or number(s) that appear in your logo.</Form.Label>
                        <Form.Control
                          type="text"
                          required
                          placeholder=""
                          onChange={handleChange}
                          data-hj-allow
                          value={state.markDesc ? state.markDesc : ""}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please provide a complete and accurate description of your logo
                        </Form.Control.Feedback>
                      </Form.Group>
                    </>
                  ) : null}
                </div>
              </div>
            </Form>
  );
}
